<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                this.$store.commit('updateField', {
                    key: 'basicInfo.countryOfResidence',
                    value: selectedItem.title,
                })

                this.$store.commit('setValue', {
                    key: 'isTaxIdRequired',
                    value: selectedItem.taxIdRequired,
                })
                this.$store.commit('setValue', {
                    key: 'isTaxIdMandatory',
                    value: selectedItem.isTaxIdMandatory,
                })
                this.$store.commit('setValue', {
                    key: 'taxIdNote',
                    value: selectedItem.taxIdNote,
                })
            }
        },
    }, // End of Component > watch
}
</script>
